import { useTranslation } from "react-i18next";
import Millimetre from "../../../../components/Math/Units/Metric/Millimetre";
import { RowBody } from "../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../components/ToolTip";

function LaengeUebergangsrohr({ value = 0 }) {
  const { t } = useTranslation("translation");

  const gesamt_laenge_uebergangs_rohr_formula = `\\displaystyle L_{min} \\ge K_{min} + L_{b min}`;
  return (
    <RowBody
      titleValue={<p>{t("aeussre.totalLengthTransitionPipe")}</p>}
      indicesValue={
        <p>
          L<sub>min</sub>
        </p>
      }
      inputValue={<span className="input">{value?.toFixed(0)}</span>}
      unitValue={<Millimetre />}
      formulaValue={
        <ToolTip
          id={"gesamt_laenge_uebergangs_rohr_formula"}
          type={IconType.FORMULA}
          formula={gesamt_laenge_uebergangs_rohr_formula}
        />
      }
    />
  );
}

export default LaengeUebergangsrohr;
